import { useUpdateCpf } from "@/app/hooks/useUpdateCpf";
import { validateCpf } from "@/app/utils/cpfFormater";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";

const formValidation = z.object({
  cpf: z
    .string()
    .min(11, "CPF é obrigatório")
    .refine((v) => validateCpf(v), "CPF Inválido")
    .transform((f) => f.replace(/\D/g, "")),
});

type formData = z.infer<typeof formValidation>;

export const useEditCpfModalController = ({
  onClose,
  open,
  sellerId,
}: {
  onClose: () => void;
  open: boolean;
  sellerId: string;
}) => {
  const { updateCpf } = useUpdateCpf();

  const form = useForm<formData>({
    resolver: zodResolver(formValidation),
  });

  const {
    register,
    formState: { errors, isSubmitting },
    handleSubmit,
    reset,
  } = form;

  const onSubmit = async ({ cpf }: formData) => {
    if (!sellerId) return;

    try {
      await updateCpf({
        id: sellerId,
        body: {
          cpf,
        },
      });
      onClose();
      reset();
    } catch (e) {
      console.error("Erro ao atualizar o CPF:", e);
    }
  };

  useEffect(() => {
    if (!open) reset();
  }, [open, reset]);

  return {
    form,
    errors,
    register,
    isSubmitting,
    handleSubmit,
    onSubmit,
  };
};
